module.exports = {"340882100":"梅城镇","340882101":"源潭镇","340882102":"余井镇","340882103":"王河镇","340882104":"黄铺镇","340882105":"槎水镇","340882106":"水吼镇","340882107":"官庄镇","340882108":"黄泥镇","340882109":"黄柏镇","340882110":"天柱山镇","340882200":"塔畈乡","340882201":"油坝乡","340882202":"龙潭乡","340882203":"痘姆乡","340882204":"五庙乡","340882400":"开发区","340882401":"旅游度假区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340882.json
// module id = 1102
// module chunks = 0